import * as yup from 'yup'

export const powerBiConfigSchema = yup.object().shape({
  orderUrl: yup
    .string()
    .trim()
    .url('Invalid Order URL')
    .required('Order URL is required'),
  token: yup.string().trim().required('Bearer Token is required'),
  isEnabled: yup.boolean().required(),
})

export type PowerBiConfigFormFields = yup.InferType<typeof powerBiConfigSchema>
